// extracted by mini-css-extract-plugin
export default {"body":"CJWManageHistory_body__Notc6","fileuploadHistory":"CJWManageHistory_fileuploadHistory__w1Dz5","heading":"CJWManageHistory_heading__xtCWk"};